// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2ywEk","footer":"ModalCreateQualiphyProcedure_footer__7ZX2B","additionData":"ModalCreateQualiphyProcedure_additionData__Xil1C"};